import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';

export const initSentry = () => {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN, // Add this to your .env file
    integrations: [browserTracingIntegration()],
    environment: process.env.NODE_ENV,

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring
    // We recommend adjusting this in production
    tracesSampleRate: 1.0,

    // Capture all console errors automatically
    autoSessionTracking: true,
  });
};

// Helper function to capture errors with form submission context
export const captureErrorWithContext = (error, formData) => {
  Sentry.withScope((scope) => {
    // Add the form data as context
    scope.setExtra("formData", formData);
    Sentry.captureException(error);
  });
};
